module.exports = __webpack_public_path__ + "img/7.9fa0c63c.png";